const seriesTitles = {
  "AGRBDL": "Biodiesel",
  "AGRBGS": "Biogas",
  "AGRBIO": "Biomass",
  "AGRCO2N": "Agriculture",
  "AGRDST": "Diesel",
  "AGRELC": "Electricity",
  "AGRGAS": "Nat. gas",
  "AGRGEO": "Geothermal",
  "AGRHET": "Heat",
  "AGRLPG": "LPG",
  "AGRSOL": "Solar",
  "AMBHET": "Ambient Heat",
  "BIOCATW": "Cattle waste",
  "BIODST1G": "Biodiesel (1G)",
  "BIODST2G": "Biodisel (2G)",
  "BIOETH1G": "Ethanol (1G)",
  "BIOETH2G": "Ethanol (2G)",
  "BIOGAS1G": "Biogas (1G)",
  "BIOGAS2G": "Biogas (2G)",
  "BIOGRA": "Grass",
  "BIOINDF": "Food waste",
  "BIOJKR": "Biojet Kerosene",
  "BIOMSW1": "MSW 1",
  "BIOMSW2": "MSW 2",
  "BIOOSR": "Rape seed",
  "BIOPIGW": "Pig waste",
  "BIORVO": "RVO",
  "BIOTLW": "Tallow",
  "BIOWCH": "Wood chips",
  "BIOWHE": "Wheat",
  "BIOWOO": "Biomass (generic)",
  "BIOWOO1": "Sawmill resid.",
  "BIOWOO2": "PCRW",
  "BIOWPE": "Wood pellets",
  "COABIT": "Bit. coal",
  "COALIG": "Lignite",
  "CYC": "Cycling",
  "DMD_IND-CAF": "Chemicals and man-made fibers",
  "DMD_IND-CON": "Construction",
  "DMD_IND-EOE": "Electrical and optical equipment",
  "DMD_IND-FAB": "Food and beverages",
  "DMD_IND-MAE": "Machinery and equipment",
  "DMD_IND-MAP": "Basic metals and fabricated metal products",
  "DMD_IND-NEM": "Non-energy mining",
  "DMD_IND-OMA": "Other manufactuting",
  "DMD_IND-ONM": "Other non-metalic mineral products",
  "DMD_IND-PX4": "Pulp, paper, publishing and printing",
  "DMD_IND-RAP": "Rubber and plastic products",
  "DMD_IND-TAP": "Textiles and textile products",
  "DMD_IND-TEM": "Transport equipment manufacture",
  "DMD_IND-WAP": "Wood and wood products",
  "DMD_RSD-BLD-APT": "Apartments",
  "DMD_RSD-BLD-ATT": "Attached",
  "DMD_RSD-BLD-DET": "Detached",
  "DMD_SRV-COM_WS": "Com. Water/Space",
  "DMD_SRV-CS_DC": "DC",
  "DMD_SRV-PUB_WS": "Pub. Water/Space",
  "DMD_SRV-PU_PLIG": "PLIG",
  "DMD_SRV-XXX_COK": "Cooking",
  "DMD_SRV-XXX_DC": "Data Centres",
  "DMD_SRV-XXX_LIG": "Lighting",
  "DMD_SRV-XXX_OEL": "Other Electric",
  "DMD_SRV-XXX_PIG": "Pub. Lighting",
  "DMD_SRV-XXX_REF": "Refrigeration",
  "DMD_TRA-F-HTRUCK": "Heavy truck",
  "DMD_TRA-F-HTRUCK-BEV": "BEV",
  "DMD_TRA-F-HTRUCK-FCV": "FCV",
  "DMD_TRA-F-HTRUCK-HEV": "HEV",
  "DMD_TRA-F-HTRUCK-ICE": "ICE",
  "DMD_TRA-F-LAND": "Freight (land)",
  "DMD_TRA-F-LTRUCK": "Light truck",
  "DMD_TRA-F-LTRUCK-BEV": "BEV",
  "DMD_TRA-F-LTRUCK-FCV": "FCV",
  "DMD_TRA-F-LTRUCK-HEV": "HEV",
  "DMD_TRA-F-LTRUCK-ICE": "ICE",
  "DMD_TRA-F-LTRUCK-PHEV": "PHEV",
  "DMD_TRA-F-MTRUCK": "Medium truck",
  "DMD_TRA-F-MTRUCK-BEV": "BEV",
  "DMD_TRA-F-MTRUCK-FCV": "FCV",
  "DMD_TRA-F-MTRUCK-HEV": "HEV",
  "DMD_TRA-F-MTRUCK-ICE": "ICE",
  "DMD_TRA-F-TRAIN": "Train",
  "DMD_TRA-P-ACTIVE": "Active modes",
  "DMD_TRA-P-BUS": "Bus",
  "DMD_TRA-P-CAR": "Private car",
  "DMD_TRA-P-CAR-BEV": "BEV",
  "DMD_TRA-P-CAR-HEV": "HEV",
  "DMD_TRA-P-CAR-ICE": "ICE",
  "DMD_TRA-P-CAR-PHEV": "PHEV",
  "DMD_TRA-P-HPT": "Heavy train",
  "DMD_TRA-P-LAND": "Passenger (land)",
  "DMD_TRA-P-LPT": "Light train",
  "DMD_TRA-P-MOT": "Motocycle",
  "DMD_TRA-P-TAXI": "Taxi",
  "DMD_TRA-R-AVIDOM": "Domestic Aviation",
  "DMD_TRA-R-AVIINT": "International Aviation",
  "DMD_TRA-R-NAV": "Navigation",
  "DMD_TRA-R-OTH": "Unspecified",
  "DMD_TRA-R-TURS": "Tourism",
  "ELCC": "Electricity",
  "ELCD": "Electricity",
  "ELE-SOL-PV": "Solar PV",
  "ENV-CH4_AGR": "Agriculture",
  "ENV-CH4_RSD": "Residential",
  "ENV-CO2": "CO2",
  "ENV-CO2_AGR": "Agriculture",
  "ENV-CO2_IND": "Industry",
  "ENV-CO2_PWR": "El. generation",
  "ENV-CO2_RSD": "Residential",
  "ENV-CO2_SRV": "Services",
  "ENV-CO2_TRA": "Transport",
  "ENV-N2O_AGR": "Agriculture",
  "FIX": "Fixed",
  "FT-RSDBIODST": "Biodiesel",
  "FT-RSDBIOETH": "Ethanol",
  "FT-RSDBIOWOO": "Biomass",
  "FT-RSDCOA": "Coal",
  "FT-RSDELC": "Electricity",
  "FT-RSDGASNAT": "Nat. Gas",
  "FT-RSDHET": "Heat",
  "FT-RSDOILKER": "Kerosen",
  "FT-RSDOILLPG": "LPG",
  "FT-RSDPEA": "Peat",
  "FT-RSDRENGEO": "Geothermal",
  "FT-RSDRENSOL": "Solar",
  "FT-TRABDL": "Bio-diesel",
  "FT-TRABNG": "Bio-CNG",
  "FT-TRACNG": "CNG",
  "FT-TRADST": "Diesel",
  "FT-TRAELC": "Electricity",
  "FT-TRAETH": "Ethanol",
  "FT-TRAGSL": "Gasoline",
  "FT-TRAH2": "Hydrogen",
  "FT-TRAKER": "Kerosene",
  "FT-TRALNG": "LNG",
  "FT_AGR": "Agriculture",
  "FT_IND": "Industry",
  "FT_RSD": "Residential",
  "FT_SRV": "Services",
  "FT_TRA": "Transport",
  "GASLNG": "LNG",
  "GASNAT": "Nat. gas",
  "HETC": "Heat",
  "HETD": "Heat",
  "IMPBIODST1G_S1": "BD import (1G-S1)",
  "IMPBIODST1G_S2": "BD import (1G-S2)",
  "IMPBIODST1G_S3": "BD import (1G-S3)",
  "IMPBIODST1G_S4": "BD import (1G-S4)",
  "IMPBIOETH1G_S1": "BE import (1G-S1)",
  "IMPBIOETH1G_S2": "ET import (1G-S2)",
  "IMPBIOETH1G_S3": "ET import (1G-S3)",
  "IMPBIOETH1G_S4": "ET import (1G-S4)",
  "IMPNRGZ": "IMPNRG",
  "INDBDL": "Biodiesel",
  "INDBGS": "Biogas",
  "INDBIO": "Biomass",
  "INDBKE": "Biokerosene",
  "INDBRW": "Bio. and ren. waste",
  "INDCO2N": "Industry",
  "INDCO2P": "Ind. Process",
  "INDCOA": "Coal",
  "INDCOK": "Coke",
  "INDDST": "Diesel",
  "INDELC": "Electricity",
  "INDGAS": "Nat. gas",
  "INDH2G": "Hydrogen",
  "INDHFO": "HFO",
  "INDKER": "Kerosene",
  "INDLPG": "LPG",
  "INDNRW": "Non-ren. waste",
  "INDNWS": "Non-ren. waste",
  "INDPEA": "Peat",
  "INDRWS": "Ren. waste",
  "INV": "Investment",
  "IRE-EXP": "Export",
  "IRE-IMP": "Import",
  "IRE-MIN": "Extraction",
  "OILCOK": "Pet. coke",
  "OILCRD": "Crude oil",
  "OILDST": "Diesel",
  "OILGSL": "Gasoline",
  "OILHFO": "HFO",
  "OILKER": "Kerosene",
  "OILLPG": "LPG",
  "PEAT": "Peat",
  "PRC_AGR": "Agriculture",
  "PRC_IND": "Industry",
  "PRC_PWR": "Power",
  "PRC_RSD": "Residential",
  "PRC_SRV": "Services",
  "PRC_SUP": "Supply",
  "PRC_TRA": "Transport",
  "PWR-BIO": "Biomass",
  "PWR-BIO-CCS": "Biomass CCS",
  "PWR-COA": "Coal",
  "PWR-COA-CCS": "Coal CCS",
  "PWR-GAS": "Natural Gas",
  "PWR-GAS-CCS": "Gas CCS",
  "PWR-H2": "Hydrogen",
  "PWR-HYD": "Hydro",
  "PWR-MSW": "Municipal Waste",
  "PWR-OCE": "Wave/tidal",
  "PWR-OIL": "Oil",
  "PWR-PEA": "Peat",
  "PWR-PEA-CCS": "Peat CCS",
  "PWR-SOL": "Solar",
  "PWR-WIN-OF": "Wind Offshore",
  "PWR-WIN-ON": "Wind Onshore",
  "PWRBIO": "Biomass",
  "PWRCO2N": "Power Generation",
  "PWRCOA": "Coal",
  "PWRDIS": "Distillate",
  "PWRGAS": "Nat. gas",
  "PWRH2G": "H2 gas",
  "PWRHFO": "Oil",
  "PWRHYD": "Hydro",
  "PWRMSW": "MSW",
  "PWRPEA": "Peat",
  "PWRWIN": "Wind",
  "R-HC_Apt_ELC_HPN1": "HP A/A H&C",
  "R-HC_Att_ELC_HPN1": "HP A/A H&C",
  "R-HC_Att_ELC_HPN2": "HP G/W H&C",
  "R-HC_Det_ELC_HPN1": "HP A/A H&C",
  "R-HC_Det_ELC_HPN2": "HP G/W H&C",
  "R-RSDCK_ELC_N1": "Electric (new)",
  "R-RSDCK_ELC_X0": "Electric (existing)",
  "R-RSDCK_GAS_N1": "Gas (new)",
  "R-RSDCK_GAS_X0": "Gas (existing)",
  "R-RSDCK_LPG_N1": "LPG (new)",
  "R-RSDCK_LPG_X0": "LPG (existing)",
  "R-RTFT-Apt_Deep": "Deep retrofit",
  "R-RTFT-Apt_Shallow": "Shallow retrofit",
  "R-RTFT-Att_Deep": "Deep retrofit",
  "R-RTFT-Att_Shallow": "Shallow retrofit",
  "R-RTFT-Det_Deep": "Deep retrofit",
  "R-RTFT-Det_Shallow": "Shallow retrofit",
  "R-SC_Apt_ELC_N1": "AC",
  "R-SC_Apt_ELC_N2": "AC (C)",
  "R-SC_Att_ELC_N1": "AC",
  "R-SC_Det_ELC_N1": "AC",
  "R-SH_Apt_ELC_HPN1": "HP A/A SH",
  "R-SH_Apt_ELC_HPN2": "HP A/W SH",
  "R-SH_Apt_ELC_N1": "El. heater SH",
  "R-SH_Apt_GAS_N1": "Gas boiler SH",
  "R-SH_Apt_KER_N1": "Kerosene SH",
  "R-SH_Apt_LPG_N1": "LPG SH",
  "R-SH_Apt_WOO_N1": "Bio Boiler SH",
  "R-SH_Att_ELC_HPN1": "HP A/A SH",
  "R-SH_Att_ELC_HPN2": "HP A/W SH",
  "R-SH_Att_ELC_N1": "El. heater SH",
  "R-SH_Att_FPL_N1": "Stove SH",
  "R-SH_Att_GAS_N1": "Gas boiler SH",
  "R-SH_Att_HVO_N1": "HVO SH",
  "R-SH_Att_KER_N1": "Kerosene SH",
  "R-SH_Att_LPG_N1": "LPG SH",
  "R-SH_Att_WOO_N1": "Bio Boiler SH",
  "R-SH_Det_ELC_HPN1": "HP A/A SH",
  "R-SH_Det_ELC_HPN2": "HP A/W SH",
  "R-SH_Det_ELC_N1": "El. heater SH",
  "R-SH_Det_FPL_N1": "Stove SH",
  "R-SH_Det_GAS_N1": "Gas boiler SH",
  "R-SH_Det_HVO_N1": "HVO SH",
  "R-SH_Det_KER_N1": "Kerosene SH",
  "R-SH_Det_LPG_N1": "LPG SH",
  "R-SH_Det_WOO_N1": "Bio Boiler SH",
  "R-SW_Apt_ELC_HPN1": "HP A/W SW",
  "R-SW_Apt_GAS_HHPN1": "Gas hybrid HP A/W SW",
  "R-SW_Apt_GAS_N1": "Gas boiler SW",
  "R-SW_Apt_HET_N1": "DH (C) SW",
  "R-SW_Apt_HET_N2": "DH (D) SW",
  "R-SW_Apt_KER_N1": "Kerosene SW",
  "R-SW_Apt_LPG_N1": "LPG SW",
  "R-SW_Apt_WOO_N1": "Bio Boiler SW",
  "R-SW_Att_ELC_HPN1": "HP A/W SW",
  "R-SW_Att_FPL_N1": "Stove wBB SW",
  "R-SW_Att_GAS_HHPN1": "Gas hybrid HP A/W SW",
  "R-SW_Att_GAS_HPN1": "Gas abs. HP A/W SW",
  "R-SW_Att_GAS_N1": "Gas boiler SW",
  "R-SW_Att_GAS_N3": "Nat.& wood stove SW",
  "R-SW_Att_HET_N1": "DH (C) SW",
  "R-SW_Att_HET_N2": "DH (D) SW",
  "R-SW_Att_HVO_N1": "HVO SW",
  "R-SW_Att_KER_N1": "Kerosene SW",
  "R-SW_Att_KER_N2": "Ker.& solar SW",
  "R-SW_Att_KER_N3": "Ker.& wood stove SW",
  "R-SW_Att_LPG_N1": "LPG SW",
  "R-SW_Det_ELC_HPN1": "HP A/W SW",
  "R-SW_Det_FPL_N1": "Stove wBB SW",
  "R-SW_Det_GAS_HHPN1": "Gas hybrid HP A/W SW",
  "R-SW_Det_GAS_HPN1": "Gas abs. HP A/W SW",
  "R-SW_Det_GAS_N1": "Gas boiler SW",
  "R-SW_Det_GAS_N3": "Nat.& wood stove SW",
  "R-SW_Det_HET_N1": "DH (C) SW",
  "R-SW_Det_HET_N2": "DH (D) SW",
  "R-SW_Det_HVO_N1": "HVO SW",
  "R-SW_Det_KER_N1": "Kerosene SW",
  "R-SW_Det_KER_N2": "Ker.& solar SW",
  "R-SW_Det_KER_N3": "Ker.& wood stove SW",
  "R-SW_Det_LPG_N1": "LPG SW",
  "R-SW_Det_WOO_N1": "Bio Boiler SW",
  "R-WH_Apt_SOL_N1": "Solar WH",
  "R-WH_Att_ELC_N1": "Electric WH",
  "R-WH_Att_SOL_N1": "Solar WH",
  "R-WH_Det_ELC_N1": "Electric WH",
  "R-WH_Det_SOL_N1": "Solar WH",
  "RENGEO": "Geothermal",
  "RENHYD": "Hydro",
  "RENOCE": "Wave/tidal",
  "RENSOL": "Solar",
  "RENWIN": "Wind",
  "RSDAHT": "Ambient Heat",
  "RSDAHT2": "Ambient Heat*",
  "RSDBDL": "Biodiesel",
  "RSDBIODST": "Biodiesel",
  "RSDBIOETH": "Ethanol",
  "RSDBIOWOO": "Biomass",
  "RSDCO2": "Residential",
  "RSDCOA": "Coal",
  "RSDELC": "Electricity",
  "RSDETH": "Ethanol",
  "RSDGAS": "Nat. gas",
  "RSDGASNAT": "Nat. gas",
  "RSDGEO": "Geothermal",
  "RSDHET": "Heat",
  "RSDKER": "Kerosene",
  "RSDLPG": "LPG",
  "RSDOILKER": "Kerosene",
  "RSDOILLPG": "LPG",
  "RSDPEA": "Peat",
  "RSDRENGEO": "Geothermal",
  "RSDRENSOL": "Solar",
  "RSDSH_Apt": "Apartments",
  "RSDSH_Att": "Attached",
  "RSDSH_Det": "Detached",
  "RSDSOL": "Solar",
  "RSDWOO": "Biomass",
  "RSD_BLD-XXX_NRGSRV-CD": "Cloth drying",
  "RSD_BLD-XXX_NRGSRV-CK": "Cooking",
  "RSD_BLD-XXX_NRGSRV-CW": "Cloth washing",
  "RSD_BLD-XXX_NRGSRV-DW": "Dish washing",
  "RSD_BLD-XXX_NRGSRV-LT": "Lighting",
  "RSD_BLD-XXX_NRGSRV-OE": "Other applications",
  "RSD_BLD-XXX_NRGSRV-PF": "Pumps and fans",
  "RSD_BLD-XXX_NRGSRV-RF": "Refrigeration",
  "RSD_BLD-XXX_NRGSRV-WS": "Water and space",
  "SBIORDST01": "OSR",
  "SBIORDST02": "Woody biomass",
  "SBIORDST03": "Ind. food waste",
  "SBIORDST04": "RVO",
  "SBIORDST05": "Tallow",
  "SBIORETH01": "Wheat",
  "SBIORETH02": "Woody biomass",
  "SBIORETH03": "Grass",
  "SBIORGAS01": "Grass",
  "SBIORGAS02": "Woody biomass",
  "SBIORGAS03": "MS waste",
  "SBIORGAS04": "IF waste",
  "SBIORGAS05": "Cattle waste",
  "SBIORGAS06": "Pig waste",
  "SEAI_BIOENERGY": "Bioenergy",
  "SEAI_COAL": "Coal",
  "SEAI_ELECTRICITY": "Electricity",
  "SEAI_HEAT": "Heat",
  "SEAI_HYDROGEN": "Hydrogen",
  "SEAI_NATGAS": "Natural gas",
  "SEAI_OIL": "Oil",
  "SEAI_OTHER_RENEWABLES": "Other renewables",
  "SEAI_PEAT": "Peat",
  "SH2PCELC_01": "Electrolyser (C)",
  "SH2PDELC_01": "Electrolyser (D)",
  "SRV-CS_NRGSRV-CK": "CS-CK",
  "SRV-CS_NRGSRV-LIG": "CS-LIG",
  "SRV-CS_NRGSRV-OEL": "CS-OEL",
  "SRV-CS_NRGSRV-REF": "CS-REF",
  "SRV-CS_NRGSRV-WS": "CS-WS",
  "SRV-PU_NRGSRV-CK": "PU-CK",
  "SRV-PU_NRGSRV-LIG": "PU-LIG",
  "SRV-PU_NRGSRV-OEL": "PU-OEL",
  "SRV-PU_NRGSRV-REF": "PU-REF",
  "SRV-PU_NRGSRV-WS": "PU-WS",
  "SRVAHT": "Ambient Heat",
  "SRVAHT2": "Ambient Heat*",
  "SRVBGS": "Biogas",
  "SRVBIO": "Biomass",
  "SRVCO2N": "Services",
  "SRVCOA": "Coal",
  "SRVELC": "Electricity",
  "SRVELC-DC-C": "El. for cooling",
  "SRVGAS": "Nat. gas",
  "SRVHET": "District Heat",
  "SRVHET-DC-LT": "Low Temp. Heat",
  "SRVLPG": "LPG",
  "SRVOIL": "Oil",
  "SRVSOL": "Solar",
  "SUPH2GC": "Hydrogen",
  "SUPH2GD": "Hydrogen",
  "TRABDL": "Biodiesel",
  "TRABJK": "Bio jet kerosene",
  "TRABNG": "Bio CNG",
  "TRACNG": "CNG",
  "TRACO2N": "Transport",
  "TRADSB": "Blended Diesel",
  "TRADST": "Diesel",
  "TRAE85": "Ethanol E85",
  "TRAELC": "Electricity",
  "TRAETH": "Ethanol",
  "TRAGSE": "Blended Gasoline",
  "TRAGSL": "Gasoline",
  "TRAH2": "Hydrogen",
  "TRAJKB": "Blended kerosene",
  "TRAKER": "Kerosene",
  "TRALNG": "LNG",
  "TRANGB": "BioCNG Blend",
  "TRAPL": "Long-range",
  "TRAPM": "Medium-range",
  "TRAPS": "Short-range",
  "VAR": "Variable",
  "VARX": "Var. taxes/subs.",
  "WLK": "Walking"
};

export default seriesTitles;
